module.exports = __webpack_public_path__ + "static/media/specialsHappy.a5e3210d.png";